// @ts-nocheck
// ========================================
// ゲームスタイル定義
// ========================================

const styles = {
  container: {
    minHeight: '100vh',
    height: '100vh',
    background: 'linear-gradient(180deg, #0a0a1a 0%, #1a1a3a 50%, #0a0a1a 100%)',
    fontFamily: '"Noto Sans JP", "Hiragino Sans", sans-serif',
    color: '#e0e0e0',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    background: 'linear-gradient(90deg, rgba(20,20,50,0.95) 0%, rgba(40,20,60,0.95) 50%, rgba(20,20,50,0.95) 100%)',
    borderBottom: '2px solid #6b4ce6',
    padding: '12px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 4px 20px rgba(107,76,230,0.3)',
    flexShrink: 0,
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    background: 'linear-gradient(90deg, #ff6b9d, #c44dff, #6b9dff)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textShadow: '0 0 30px rgba(196,77,255,0.5)',
    letterSpacing: '2px',
  },
  mainArea: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
  leftSidePanel: {
    width: '280px',
    flexShrink: 0,
    background: 'rgba(15,15,30,0.95)',
    borderRight: '1px solid rgba(107,76,230,0.3)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  gameBoard: {
    display: 'grid',
    // TopBar, P2Area, P1Area, ActionFooter
    // P1（自分）エリアを優先して大きく、P2（相手）エリアを圧縮
    gridTemplateRows: 'auto minmax(0, 0.8fr) minmax(0, 1.2fr) auto',
    flex: 1,
    minHeight: 0,
    gap: '8px',
    padding: '12px',
    overflow: 'hidden',
    position: 'relative', // 選択オーバーレイ用
  },
  playerArea: {
    display: 'grid',
    gridTemplateColumns: '200px 1fr 120px',
    gap: '12px',
    padding: '8px',
    borderRadius: '12px',
    minHeight: 0,
    overflow: 'hidden',
  },
  infoPanel: {
    background: 'rgba(20,20,40,0.8)',
    borderRadius: '12px',
    padding: '12px',
    border: '1px solid rgba(107,76,230,0.3)',
    overflow: 'auto',
    minHeight: 0,
  },
  cardZoneContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center',
  },
  cardZoneItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  cardInfoPanel: {
    flex: 1,
    padding: '12px',
    overflowY: 'auto',
    minHeight: 0,
  },
  fieldArea: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minHeight: 0,
    overflow: 'hidden',
    flex: 1,
  },
  monsterZone: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'center',
    minHeight: '140px',
    flexShrink: 0,
  },
  cardSlot: {
    width: '100px',
    height: '130px',
    border: '2px dashed rgba(107,76,230,0.4)',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(20,20,40,0.5)',
    transition: 'all 0.3s ease',
  },
  handArea: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'center',
    padding: '8px',
    minHeight: '150px',
    overflowX: 'auto',
    flexShrink: 0,
  },
  centerZone: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',
    padding: '12px',
    background: 'linear-gradient(90deg, rgba(20,20,50,0.6) 0%, rgba(40,30,60,0.8) 50%, rgba(20,20,50,0.6) 100%)',
    borderRadius: '12px',
    border: '1px solid rgba(107,76,230,0.3)',
    flexShrink: 0,
  },
  phaseIndicator: {
    display: 'flex',
    gap: '8px',
  },
  phaseButton: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '12px',
    transition: 'all 0.3s ease',
  },
  actionButton: {
    padding: '10px 24px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '14px',
    background: 'linear-gradient(135deg, #6b4ce6 0%, #9d4ce6 100%)',
    color: '#fff',
    boxShadow: '0 4px 15px rgba(107,76,230,0.4)',
    transition: 'all 0.3s ease',
  },
  lifeBar: {
    height: '24px',
    borderRadius: '12px',
    background: 'rgba(0,0,0,0.5)',
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.2)',
  },
  lifeBarFill: {
    height: '100%',
    borderRadius: '12px',
    transition: 'width 0.5s ease',
  },
  spToken: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalContent: {
    background: 'linear-gradient(135deg, #1a1a3a 0%, #2a2a4a 100%)',
    borderRadius: '16px',
    padding: '24px',
    maxWidth: '500px',
    width: '90%',
    border: '2px solid #6b4ce6',
    boxShadow: '0 0 50px rgba(107,76,230,0.5)',
  },
  log: {
    background: 'rgba(0,0,0,0.4)',
    borderRadius: '8px',
    padding: '8px',
    maxHeight: '120px',
    overflowY: 'auto',
    fontSize: '11px',
    lineHeight: '1.6',
  },
};

export default styles;
